module.exports = __webpack_public_path__ + "img/star01.3bbaa035.png";